import {
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import moment from "moment";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40vw",
    bgcolor: "background.paper",
    border: "none",
    borderRadius: "1rem",
    boxShadow: 24,

    p: 4,
    "@media(max-width: 900px)": {
        width: "150vw",
        maxHeight: "70vh",
        overflowX: "scrollable",
        overflowY: "scrollable",
    },
}

const PendingXMLSs = ({ handleClose, fuelData }) => {
  const sortedFuelData = [...fuelData].sort((a, b) => new Date(b.paymentTime) - new Date(a.paymentTime));
  
  return (
    <Box sx={style} className="all_modals">
      {console.log(fuelData)}
      <h2>Fuel data</h2>
      <Typography>
        <TableContainer component={Paper}>
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Date/Time</TableCell>
                  <TableCell>Site name</TableCell>
                  <TableCell>Fuel Type</TableCell>
                  <TableCell>Fuel price</TableCell>
                  <TableCell>Fuel quantity</TableCell>
                  <TableCell>Fuel value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedFuelData.map((data) => (
                  <TableRow>
                    <TableCell>{moment(data.paymentTime).format("DD-MM-YY/HH:MM")}</TableCell>
                    <TableCell>{data.siteName}</TableCell>
                    <TableCell>{data.fuelType}</TableCell>
                    <TableCell>{data.fuelPrice}</TableCell>
                    <TableCell>{data.fuelQuantity}</TableCell>
                    <TableCell>£{data.fuelValue}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </TableContainer>
      </Typography>
      <section style={{ display: "flex", justifyContent: "space-around", marginTop:"10px" }}>
        <Button variant="contained" color="error" onClick={handleClose}>
          Close
        </Button>
      </section>
    </Box>
  );
};
export default PendingXMLSs;
